  <template>
    <div id="wrapper" :key="valuekey">
        <div class="content-page">
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">{{$t('string.msg.connect.truck.register.title')}}</h4>

                            </div>
                        </div>
                    </div>
                    
                    <!-- Form row -->
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card-box">
                                <p class="sub-header">
                                    {{$t('string.msg.connect.truck.register.description')}}
                                </p>

                                <form>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{$t('string.msg.connect.truck.register.trucker')}}
                                            </label>
                                            <select v-model="data.trucker" class="form-control">
                                                <option value="-1" selected>{{$t('string.msg.connect.truck.placeholder.register.trucker')}}</option>
                                                <option :value="item._id" v-bind:key="item._id" v-for="item in truckers" >{{camelize(item.firstName)}}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                             <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{$t('string.msg.connect.truck.register.truck')}}
                                            </label>
                                            <select v-model="data.truck" class="form-control">
                                                <option value="-1" selected>{{$t('string.msg.connect.truck.placeholder.register.truck')}}</option>
                                                <option :value="item" v-bind:key="item._id" v-for="item in trucks" >{{camelize(item.name) +
                                                         ' - ' + $t(`string.msg.type.truck.${item.vehicleType}`) }}</option>
                                            </select>
                                        </div>
                                        <div class="form-group col-md-6" v-show="checkTruckType(data.truck.vehicleType) == -1">
                                          <label class="col-form-label">
                                             <code class="highlighter-rouge">*</code>
                                             {{$t('string.msg.connect.truck.register.trucktrailer')}}
                                          </label>
                                            <multiselect 
                                                v-model="selectedTruckTrailers" 
                                                :options="truckTrailers"
                                                :multiple="true"
                                                track-by="name"
                                                :custom-label="customLabel"
                                                >
                                            </multiselect>
                                         
                                        </div>
                                    </div>

                                <br><br><br>
                                 <div class="d-flex justify-content-between bd-highlight mb-3">
                                        <!-- <button @click="clearForm" class="btn btn-secondary w-20">{{$t('string.msg.form.btn.clear')}}</button> -->
                                        <button  class="btn btn-warning w-20 text-dark-gray">{{$t('string.msg.form.btn.add')}}</button>
                                        <button  class="btn btn-danger w-20">{{$t('string.msg.form.btn.save')}}</button>
                                    </div>
                                    <br><br>
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th scope="col">{{$t('string.msg.connect.truck.table.header.trucker')}}</th>
                                                <th scope="col">{{$t('string.msg.connect.truck.table.header.truck')}}</th>
                                                <th scope="col">{{$t('string.msg.connect.truck.table.header.trucktrailer')}}</th>
                                                <th scope="col">{{$t('string.msg.connect.truck.table.header.remove')}}</th>
                                            </tr>
                                        </thead>
                                            <tbody >
                                                <tr >
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td><button @click="remove()" class="btn btn-danger w-20">X</button></td>
                                                </tr>
                                            </tbody>
                                    </table>
                                    
                                    <div v-if="errors.length" class="alert alert-danger">
                                        <p class="lead">{{$t('response.msg.error.empty.fields')}}</p>
                                        <ul>
                                            <li v-bind:key="error" v-for="error in errors">{{ error }}</li>
                                        </ul>
                                    </div>

                                </form>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <Spinner />
        <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
    </div>
</template>

<script>
import Controller from './CrtConnectTruck';
import Spinner from '../../../components/layout/Spinner';
import Toast from '../../../components/layout/Toast';
import Confirmation from '../../../components/layout/Confirmation';
import Multiselect from 'vue-multiselect';

// import List from './ListTruck';

export default {
  name: 'connectTrucks',
  components: { 
    Spinner,
    Toast,
    Controller,
    Confirmation,
    Multiselect
  
},
  data() {
      return {
        errors: [],
        valuekey: 0,
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        truckers:[],
        trucks:[],
        truckTrailers:[],
        selectedTruckTrailers: [],
        needTruckTrailer:-1,
        data: {
            truck: {},
            trucker: {},

        }
    }
  },

  methods: Controller.methods,
  created() {
  },
  computed: {
  },
  mounted(){
      Controller.methods.init(this);
  }
}
</script>
   <style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

